export default "__VITE_ASSET__vmEFWJwn__"